import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-jm",
  "use": "icon-icon-jm-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-jm\">\n  <g fill-rule=\"evenodd\">\n    <path d=\"m0 0 256 256L0 512zm512 0L256 256l256 256z\" />\n    <path fill=\"#090\" d=\"m0 0 256 256L512 0zm0 512 256-256 256 256z\" />\n    <path fill=\"#fc0\" d=\"M512 0h-47.7L0 464.3V512h47.7L512 47.7z\" />\n    <path fill=\"#fc0\" d=\"M0 0v47.7L464.3 512H512v-47.7L47.7 0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol